<template>
    <div class="draft-overview-container" v-if="!compareMode">
        <div class="header">
            <div class="header-left">
                <span class="top-text">Draft Overview</span>
                <span class="bottom-text">[Review, refine, and edit your draft - and generate headlines before
                    finalizing]</span>
            </div>
            <div class="header-right">
                <div class="generate-title" @click="getGenerateTitles">
                    <img style="height: 22px;" :src="require('@/assets/icons/title-generater.svg')" />
                    <div>Generate Headlines</div>
                </div>
                <!-- <v-menu v-model="showRefineDialog" :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                        <div class="generate-title" v-bind="props">
                            <img style="height: 22px;" :src="require('@/assets/icons/refine.svg')" />
                            <div>Modify</div>
                            <img :src="require('@/assets/icons/dropdown.svg')" />
                        </div>
                    </template>
                    <div class="refine-container">
                        <div class="refine-header">
                            <div>MODIFY</div>
                            <div>LIMIT: 3 Refinements Max</div>
                        </div>
                        <div class="length-wrapper">
                            <span class="refine-type">Length</span>
                            <div class="slider-wrapper">
                                <div class="slider-left">
                                    <img :src="require('@/assets/icons/crisper.svg')">
                                    <span>Concise</span>
                                </div>
                                <div class="slider-mid">
                                    <v-slider v-model="refineLengthValue" show-ticks="always" :max="4" :min="0"
                                        :step="2" tick-size="12" hide-details class="tick-slider"></v-slider>
                                </div>
                                <div class="slider-left">
                                    <img :src="require('@/assets/icons/expand.svg')">
                                    <span>Extended</span>
                                </div>
                            </div>
                        </div>
                        <div class="length-wrapper">
                            <span class="refine-type">Language</span>
                            <div class="slider-wrapper">
                                <div class="slider-left">
                                    <img :src="require('@/assets/icons/factual.svg')">
                                    <span>Essential</span>
                                </div>
                                <div class="slider-mid">
                                    <v-slider v-model="refineDetailValue" show-ticks="always" :max="4" :min="0"
                                        :step="2" tick-size="12" hide-details class="tick-slider"></v-slider>
                                </div>
                                <div class="slider-left">
                                    <img :src="require('@/assets/icons/embellished.svg')">
                                    <span>Enhanced</span>
                                </div>
                            </div>
                        </div>
                        <div class="refine-footer">
                            <div class="refine-left-footer">
                                <span class="note">NOTE:</span>
                                <span>Refine works on the original version only, not refined ones.</span>
                            </div>
                            <button class="refine-right-footer" :disabled="refinePrLoader || prVersions.length >= 4"
                                @click="refinePr">
                                <p>Fine Tune</p>
                                <Svg v-if="!refinePrLoader" :src="StarIcon" fill="white"></Svg>
                                <v-progress-circular v-else indeterminate :size="18" :width="2"></v-progress-circular>
                            </button>
                        </div>
                    </div>
                </v-menu> -->

            </div>
        </div>
        <div class="details-container" v-if="prVersions">
            <div class="container-header">
                <div class="version-wrapper">
                    <div :class="['version-name', { 'active-version': activeVersion === index }]"
                        v-for="(pr, index) in prVersions" @click="updateActiveVersion(index)">
                        <div v-if="activeVersion === index && index != 0" class="check">
                            <img :src="require('@/assets/icons/check-icon.svg')" />
                        </div>
                        {{ index === 0 ? 'Original Version' : `Version ${pr.versionNumber}` }}
                    </div>
                </div>

                <div class="btns" v-if="!isEditing">
                    <button class="edit-btn" @click="editPr">
                        <Svg :src="EditIcon" fill="black"></Svg>
                    </button>
                    <button class="edit-btn" @click="downloadPr(activeVersion)" :disabled="downloadPrLoader">
                        <v-progress-circular v-if="downloadPrLoader" indeterminate :size="18" :width="2" />
                        <img v-else :src="require('@/assets/icons/download.svg')" />
                    </button>
                    <button class="compare-btn" v-if="prVersions.length > 1" @click="handleCompareBtn">
                        <img :src="require('@/assets/icons/compare.svg')" />
                        Compare
                    </button>
                </div>
                <div v-else class="btns">
                    <button class="compare-btn" @click="savePr" :disabled="previousVersion === editedVersion">
                        <Svg :src="require('@/assets/icons/save.svg')" fill="#262626"></Svg>
                        Save Changes
                    </button>
                    <button class="edit-btn" @click="cancelPrChanges">
                        <img :src="require('@/assets/icons/close.svg')"></img>
                    </button>
                </div>
            </div>

            <div class="pr-details">
                <div class="pr-title">{{ prVersions[activeVersion]?.prTitle }}</div>
                <div class="pr-details-wrapper" v-html="cleanedPrContent(prVersions[activeVersion]?.prContent)" ref="detailsContainer"
                    id="edit-container" v-if="!isEditing"></div>
                <div v-show="isEditing" class="editor-wrapper">
                    <div ref="editorContainer">
                        <div ref="editor" class="quill-editor"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="compare-container" v-else>
        <div class="compare-container-header">
            <button class="back-btn" @click="closeCompareMode">
                <img :src="require('@/assets/icons/back-arrow.svg')" alt="">
            </button>
            <span class="header-left">Compare PR</span>
        </div>
        <div class="compare-content">
            <div class="details-container">
                <div class="compare-select-wrapper">
                    <div class="select-download-wrapper">
                        <v-select v-model="firstSelectedVersion" :items="filteredFirstList" hide-details
                            :item-title=getOptionsTitle :item-value="getItemIndex" variant="outlined" density="compact"
                            class="select-version">
                            <template #item="{ item, index, props }">
                                <div v-bind="props"
                                    :class="['selection-list', { 'selected-item': prVersions[firstSelectedVersion].versionNumber === item.raw.versionNumber, 'last-item': index === filteredFirstList.length - 1 }]">
                                    <p>{{ item.title }}</p>
                                    <div v-if="prVersions[firstSelectedVersion].versionNumber === item.raw.versionNumber"
                                        class="tick-icon">
                                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                                    </div>
                                </div>
                            </template>
                        </v-select>
                        <button class="edit-btn" @click="downloadPr(firstSelectedVersion)">
                            <img :src="require('@/assets/icons/download.svg')" />
                        </button>
                    </div>
                    <button class="final-pr" @click="finalizePr(firstSelectedVersion)">
                        <p>Finalize</p>
                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                    </button>
                </div>
                <div class="pr-details">
                    <div class="details-title"> {{ prVersions[firstSelectedVersion].prTitle }}</div>
                    <div class="pr-details-wrapper" v-html="cleanedPrContent(prVersions[firstSelectedVersion].prContent)">
                    </div>
                </div>
                <div class="footer-final-btn">
                    <button class="final-pr" @click="finalizePr(firstSelectedVersion)">
                        <p>Finalize This</p>
                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                    </button>
                </div>
            </div>
            <div class="details-container">
                <div class="compare-select-wrapper">
                    <div class="select-download-wrapper">
                        <v-select v-model="secondSelectedVersion" :items="filteredSecondList" hide-details
                            :item-title=getOptionsTitle :item-value="getItemIndex" variant="outlined" density="compact"
                            class="select-version">
                            <template #item="{ item, index, props }">
                                <div v-bind="props"
                                    :class="['selection-list', { 'selected-item': prVersions[secondSelectedVersion].versionNumber === item.raw.versionNumber, 'last-item': index === filteredSecondList.length - 1 }]">
                                    <p>{{ item.title }}</p>
                                    <div v-if="prVersions[secondSelectedVersion].versionNumber === item.raw.versionNumber"
                                        class="tick-icon">
                                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                                    </div>
                                </div>
                            </template>
                        </v-select>
                        <button class="edit-btn" @click="downloadPr(secondSelectedVersion)">
                            <img :src="require('@/assets/icons/download.svg')" />
                        </button>
                    </div>
                    <button class="final-pr" @click="finalizePr(secondSelectedVersion)">
                        <p>Finalize</p>
                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                    </button>
                </div>
                <div class="pr-details">
                    <div class="details-title"> {{ prVersions[secondSelectedVersion].prTitle }}</div>
                    <div class="pr-details-wrapper" v-html="cleanedPrContent(prVersions[secondSelectedVersion]?.prContent)">
                    </div>
                </div>
                <div class="footer-final-btn">
                    <button class="final-pr" @click="finalizePr(secondSelectedVersion)">
                        <p>Finalize This</p>
                        <img :src="require('@/assets/icons/tick-icon.svg')" />
                    </button>
                </div>
            </div>
        </div>
    </div>
    <v-navigation-drawer v-if="showGenerateDialog" location="right" temporary v-model="showGenerateDialog" :width="700">
        <div class="dialog-container">
            <div class="dialog-wrapper">
                <div class="dialog-header">
                    <div class="header-title">Generate Headlines</div>
                    <button class="circle" @click="showGenerateDialog = false">
                        <img :src="require('@/assets/icons/close.svg')" alt="">
                    </button>
                </div>
                <div class="loader-container black" v-if="generateTitleLoader">
                    <RotatingLoader v-if="generateTitleLoader" :size="30" :speed="0.6" label="Loading Headlines" />
                </div>
                <div class="current-title-wrapper" v-if="!generateTitleLoader">
                    <div class="current-title"> Current Headlines</div>
                    <div class="title-desc">
                        {{ prVersions[activeVersion]?.prTitle }}
                    </div>
                </div>
                <div class="current-title-wrapper" v-if="!generateTitleLoader">
                    <div class="suggestion-header">
                        <img class="dynamic" :src="require('@/assets/icons/dynamic-outline.svg')" />
                        <div class="suggested-title">Suggested Headlines</div>
                    </div>
                    <div class="all-suggestion">
                        <div class="suggestion-container" v-for="(suggestion, index) in suggestions">
                            <div class="sugesstion-detail">
                                <div class="sugessted-headline">{{ suggestion.headline }}</div>
                            </div>
                            <button class="replace-btn" :disabled="replaceTitleLoader"
                                @click="replaceTitle(suggestion.headline, index)">
                                <img v-if="!replaceTitleLoader" :src="require('@/assets/icons/replace.svg')" alt="">
                                <div class="replace-title">Replace Title</div>
                                <v-progress-circular v-if="replaceTitleLoader" indeterminate :size="18"
                                    :width="2"></v-progress-circular>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </v-navigation-drawer>
    <CommonPopup v-if="showCommonPopup" :showCommonPopup="showCommonPopup" :popupType="popupType"
        @confirm-action="handlePopupConfirmation" />
</template>

<script>
import EditIcon from '@/assets/icons/edit.svg';
import StarIcon from '@/assets/icons/star.svg';
import axiosInstance from '@/axiosInterceptor';
import CommonSnackBar from '@/components/CommonSnackbar.vue';
import { downloadPr } from '@/helper/downloadPr';
import { saveDraft } from '@/helper/saveAsDraft';
import { Eventbus } from '@/plugins/eventBus';
import moment from 'moment-timezone';
import Quill from 'quill';
import { marked } from 'marked';
import 'quill/dist/quill.snow.css';
import CommonPopup from '@/components/CommonPopup.vue';
import RotatingLoader from '@/components/CircularProgressBar.vue'
export default {
    props: {
        prId: {
            type: String
        },
        prTypeId: {
            type: String
        },
        prName: {
            type: String
        },
        prevStepsQues: {
            type: Array
        },
        prVersions: {
            type: Array,
            default: []
        },
        activeVersion: {
            type: Number,
            default: 0
        },
        compareMode: {
            type: Boolean
        }
    },
    components: {
        CommonPopup,
        RotatingLoader,
    },
    data() {
        return {
            EditIcon,
            StarIcon,
            suggestions: [
                {
                    tag: 'Fatual',
                    suggestion: 'Expands Financial Technology Reach Across South and Southeast Asia'
                },
                {
                    tag: 'Clever',
                    suggestion: 'Fuels Finance’s Next Chapter in Asia’s Fast-Growing Markets'
                },
                {
                    tag: 'Engaging',
                    suggestion: 'Transforming Finance in Asia: CODESTAX.AI Leads the Next Wave of Innovation!'
                }
            ],
            showGenerateDialog: false,
            generateTitleLoader: false,
            replaceTitleLoader: false,
            showRefineDialog: false,
            refinePrLoader: false,
            refineLengthValue: 2,
            refineDetailValue: 2,
            firstSelectedVersion: 0,
            secondSelectedVersion: null,
            editor: null,
            isEditing: false,
            showCommonPopup: false,
            popupType: null,
            switchActiveVersion: null,
            previousVersion: null,
            editedVersion: null,
            downloadPrLoader: false,
        }
    },
    watch: {
        prVersions: {
            deep: true,
            handler(newValue) {
                this.$emit('update:prVersions', newValue);
            }
        }
    },
    computed: {
        filteredFirstList() {
            return this.prVersions.filter(
                (item, index) => index !== this.secondSelectedVersion
            );
        },

        filteredSecondList() {
            return this.prVersions.filter(
                (item, index) => index !== this.firstSelectedVersion
            );
        },

    },
    methods: {
        cleanedPrContent(prContent) {
            if (typeof prContent !== 'string') return '';

            return prContent;
        },
        handlePopupConfirmation(val) {
            this.showCommonPopup = false;
            if (val === 'yes') {
                if (this.popupType === 'withoutSave') {
                    this.isEditing = false;
                } else {
                    this.$emit('update:activeVersion', this.switchActiveVersion);
                    this.switchActiveVersion = null;
                    this.isEditing = false;
                }
            }
        },
        updateActiveVersion(index) {
            this.switchActiveVersion = index;
            if (this.isEditing) {
                if (this.prVersions[this.activeVersion].prContent !== this.editor.root.innerHTML) {
                    this.popupType = 'switchVersionWithoutSave';
                    this.showCommonPopup = true;
                } else {
                    this.$emit('update:activeVersion', index);
                }
                this.isEditing = false;
            } else {
                this.$emit('update:activeVersion', index);
            }
        },
        getGenerateTitles() {
            this.showGenerateDialog = true;
            this.generateTitleLoader = true;
            let payload = {
                inputBrief: this.prevStepsQues.staticQuestion,
                prContent: this.prVersions[this.activeVersion].prContent,
                dynamicQuestions: this.prevStepsQues?.dynamicQuestions
                
            };
            axiosInstance.post('/pr/refineHeadline', payload)
                .then((response) => {
                    this.suggestions = response.data.data.options;
                    this.suggestions.forEach((suggestion) => {
                        suggestion.replaceTitleLoader = false;
                    })
                })
                .catch(() => {
                    Eventbus.emit('commonSnackbar', {
                        snackType: "refine",
                        message: "failed to fetch suggested titles details"
                    });
                    this.showGenerateDialog = false;
                })
                .finally(() => {
                    this.generateTitleLoader = false;
                })
        },
        async replaceTitle(selectedSuggestion, index) {
            this.suggestions[index].replaceTitleLoader = true;
            const activePrVersion = this.prVersions[this.activeVersion];
            const updatedPrContent = activePrVersion.prContent.replace(
            /<title>(.*?)<\/title>/i,
            `<title>${selectedSuggestion}</title>`
            );

            const payload = {
                prId: this.prId,
                typeId: this.prTypeId,
                prTitle: selectedSuggestion,
                versionNumber: this.prVersions[this.activeVersion].versionNumber,
                prContent: updatedPrContent
            }
            await saveDraft(payload);
            this.suggestions[index].replaceTitleLoader = false;
            this.prVersions[this.activeVersion].prTitle = selectedSuggestion;
            this.showGenerateDialog = false;
            Eventbus.emit('commonSnackbar', {
                snackType: 'replace',
            });
        },
        editPr() {
            this.$emit('update:isEditingFinalPr', this.isEditing);
            const html = this.prVersions[this.activeVersion].prContent
                            .replace(/<div\b/g, '<p')
                            .replace(/<\/div>/g, '</p>');
            this.previousVersion = html;
            this.editedVersion = html;
            this.editor.root.innerHTML = html;
            
            this.isEditing = !this.isEditing;
        },
        cancelPrChanges() {
            if (this.previousVersion == this.editedVersion) {
                this.isEditing = false;
                this.$emit('update:isEditingFinalPr', this.isEditing);
            } else {
                this.isEditing = false;
                this.$emit('update:isEditingFinalPr', this.isEditing);
            }
        },
        async savePr() {
            let payload = {
                versionNumber: this.prVersions[this.activeVersion].versionNumber,
                prContent: this.editor.root.innerHTML,
                prTitle: this.prVersions[this.activeVersion].prTitle,
                prId: this.prId,
                typeId: this.prTypeId
            }
            await saveDraft(payload);
            this.prVersions[this.activeVersion].prContent = this.editor.root.innerHTML;
            this.isEditing = !this.isEditing;
            this.$emit('update:isEditingFinalPr', this.isEditing);
        },
        async downloadPr(version) {   
            this.downloadPrLoader = true;
            let payload = {
                prId: this.prId,
                version: this.prVersions[version].versionNumber,
                flowType: "PR",
                versionType: ''
            }
            console.log("payload", payload);
            let prTitle = this.prVersions[0]?.prTitle;
            await downloadPr(payload, prTitle); // version number or Pr doc name
            this.downloadPrLoader = false;
        },
       async refinePr() {      
            this.refinePrLoader = true;
            let payload = {
                inputBrief: this.prevStepsQues.staticQuestion,
                serviceType: "refine_pr",
                prId: this.prId,
                prLength: this.refineLengthValue <= 2 ? "CRISPER" : "EXPAND",
                prDetail: this.refineDetailValue <= 2 ? "FACTUAL" : "Embellished",
                prContent: this.prVersions[this.activeVersion].prContent,
                dynamicQuestions: this.prevStepsQues.dynamicQuestions
            };
            try {
              const response = await axiosInstance.post('/pr/modify', payload)
              if (response.status ===200) {
                 let newPr = {
                        prTitle: response.data.data.prTitle,
                        prContent: response.data.data.prContent,
                        versionNumber: response.data.data.versionData.latestPrVersionNumber,
                        prId: this.prId,
                        createdAt: moment().valueOf()
                    };
                    this.prVersions.push(newPr);
                    Eventbus.emit('commonSnackbar', {
                        snackType: "refine",
                    });
                    this.updateActiveVersion(this.prVersions.length - 1);
                    this.showRefineDialog = false;
              }
            } catch (error) {
                console.error("Error generating PR:", error);
                    if (error.response?.status === 502 || error.code === 'ERR_NETWORK' || error.response?.status === 504) {
                        let attempts = 0;
                        let maxAttempts = 40;
                        const intervalTime = 15000;

                        const intervalId = setInterval(async () => {
                            attempts++;
                            try {
                                await this.fetchPrDetails();
                                if (this.prDetails != null && this.prDetails.prVersions.length>=2) {
                                    clearInterval(intervalId);
                                    this.refinePrLoader = false;
                                     this.showRefineDialog = false;
                                } else if (attempts >= maxAttempts) {
                                    clearInterval(intervalId);
                                    this.refinePrLoader = false;
                                this.showRefineDialog = false;
                                }
                            } catch (pollError) {
                                console.error("Error during polling:", pollError);
                                clearInterval(intervalId);
                               this.refinePrLoader = false;
                                this.showRefineDialog = false;
                                Eventbus.emit('commonSnackbar', {
                                    snackType: 'error',
                                    message: 'Failed to generate PR. Please try again later.'
                                });
                            }
                        }, intervalTime);
                    }
            } finally {
                this.refinePrLoader = false;
                this.showRefineDialog = false;
            }

        },
        handleCompareBtn() {
            this.$emit('update:compareMode', true);
            this.firstSelectedVersion = 0;
            if (this.activeVersion === 0) {
                this.secondSelectedVersion = this.prVersions.length - 1;
            } else {
                this.secondSelectedVersion = this.activeVersion;
            }
        },

        getItemIndex(selectedItem) {
            return this.prVersions.findIndex(item => item === selectedItem);
        },

        getOptionsTitle(selectedItem) {
            return selectedItem.versionNumber > 0 ? `Version ${selectedItem.versionNumber}` : 'Original Version';
        },

        async finalizePr(selectedVersion) {
            this.updateActiveVersion(selectedVersion);
            this.$emit('finalizePr');
        },

        closeCompareMode() {
            this.$emit('update:compareMode', false);
        },
    },
    mounted() {
        this.editor = new Quill(this.$refs.editor, {
            theme: 'snow',
            modules: {
                toolbar: [
                    [{ header: [1, 2, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link', 'blockquote', 'code-block'],
                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                    [{ color: [] }, { background: [] }],
                ],
            },
        });
        this.editor.on('text-change', () => {
            this.editedVersion = this.editor.root.innerHTML;
        });

    }
}
</script>

<style scoped>
.draft-overview-container,
.compare-container {
    width: 100%;
    height: 100%;
    max-width: 805px;
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding: 24px 8px 40px 8px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-left {
    display: flex;
    flex-direction: column;
    width: 360px;
}

.top-text {
    font-size: var(--header-font-size);
    font-weight: 600;
    text-align: left;
    color: #FAFAFA;
}

.bottom-text {
    font-size: var(--normal-font-size);
    text-align: left;
    color: #FFFFFF99;
    font-style: italic;
}

.header-right {
    display: flex;
    align-items: center;
    gap: 1em;
}

.generate-title {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    gap: 10px;
    border-radius: 24px;
    border: 1px solid #FFFFFF33;
    color: white;
    cursor: pointer;
    font-size: 16px;
    line-height: 0.6;
    letter-spacing: 0.1px;
}

.details-container {
    display: flex;
    flex-direction: column;
    gap: 1em;
    flex: 1;
}

.container-header {
    display: flex;
    justify-content: space-between;
    gap: 1em;
}

.version-wrapper {
    display: flex;
    gap: 8px;
}

.version-name {
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 5rem;
    padding: 6px 20px;
    background: #FFFFFF33;
    color: #E5E5E5;
    border: none;
    cursor: pointer;
}

.active-version {
    background: white;
    color: var(--primary-font-color);
    font-size: var(--normal-font-size);
}

.check {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 15px;
    height: 15px;
    padding: 12px;
    border-radius: 50%;
}

.check .v-icon {
    width: 10px;
    height: 10px;
}

.btns {
    display: flex;
    gap: 1em;
}

.edit-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    border-radius: 50%;
    background: white;
    color: #404040;
    border: 1px solid #A3A3A3;
}

.compare-btn {
    height: 40px;
    display: flex;
    gap: 8px;
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    border-radius: 20px;
    background: white;
    color: #404040;
    border: 1px solid #A3A3A3;
}

.pr-details {
    display: flex;
    flex-direction: column;
    gap: 2em;
    padding: 3em;
    align-items: left;
    background-color: white;
    border-radius: 24px;
}

.details-title {
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #171717;
}


.dialog-container {
    background-color: #FFF;
    height: 100%;
}

.dialog-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 1.5em;
    padding: 2em;
    background-color: #FFF;
    align-items: flex-start;
}

.dialog-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-title {
    font-family: 'Inter', sans-serif;
    font-size: 24px;
    font-weight: 600;
    text-align: left;
    color: #171717;
}

.circle {
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 1em;
    border: 2px solid #D4D4D4;
}

.current-title-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.current-title {
    color: #737373;
    font-size: 14px;
    font-weight: 600;
}

.suggested-title {
    font-size: 14px;
    font-weight: 600;
    background: var(--primary-gradient-with-white);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    display: inline-block;

}

.dynamic {
    width: 20px;
    height: 20px;
}


.title-desc {
    padding: 1em;
    display: flex;
    text-align: left;
    align-items: center;
    background-color: #F5F5F5;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    font-weight: 600;
    font-size: var(--normal-font-size);
}

.suggestion-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.all-suggestion {
    display: flex;
    flex-direction: column;
    gap: 1.5em;
}

.suggestion-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1em;
    border-radius: 8px;
    background-color: #F5F5F5;
    border: 1px solid #E5E5E5;
    border-radius: 8px;
    gap: 1em;
}

.sugesstion-detail {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 4;
}

.sugessted-headline {
    font-weight: 600;
    font-size: var(--normal-font-size);
}

.suggestion-tag {
    color: var(--primary-font-color);
    font-size: 14px;
    font-weight: 600;
}

.replace-title {
    font-weight: 600;
    font-size: 14px;
}

.replace-btn {
    height: 40px;
    display: flex;
    flex: 1;
    gap: 8px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    padding: 4px 12px;
    border: 1px solid var(--primary-font-color);
    color: var(--primary-font-color);
    white-space: nowrap;
}

.refine-container {
    font-family: 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 1em;
    background-color: white;
    border-radius: 8px;
    width: 100%;
    min-width: 600px;
    border: 1px solid #E5E5E5;
    box-shadow: 0px 12px 12px 0px #00000026;

}

.refine-header {
    display: flex;
    justify-content: space-between;
    padding: 12px 20px;
    border-bottom: 1px solid #E5E5E5;
    color: #404040;
    text-transform: uppercase;
}

.length-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 0px 1.5em 1.5em 1.5em;
    border-bottom: 1px solid #E5E5E5;
}

.refine-type {
    color: #171717;
}

.slider-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #F5F5F5;
    border-radius: 8px;
    padding: 1em;
}

.slider-left {
    display: flex;
    gap: 8px;
    align-items: center;
    color: #262626;
}

.slider-mid {
    width: 50%;
}

.tick-slider {
    color: #A3A3A3;
    --v-slider-track-height: 0;
}

.tick-slider :deep(.v-slider-track__tick) {
    background-color: #A3A3A3;
    border-radius: 50%;
}

.tick-slider :deep(.v-slider-track__ticks) {
    background-color: #E5E5E5;
}

.tick-slider :deep(.elevation-2) {
    background-color: #737373;
    width: 12px;
    height: 12px;
    box-shadow: none !important;
}

.tick-slider :deep(.v-slider-thumb) {
    border: 2px solid #737373;
    border-radius: 50%;
    padding: 4px;
    background-color: white;
}

.tick-slider :deep(.v-slider-track__tick--first) {
    margin-inline-start: 0px;
}

.tick-slider :deep(.v-slider-track__tick--last) {
    margin-inline-start: calc(100% - var(--v-slider-tick-size) + 10px);
}

.tick-slider :deep(.v-slider-thumb__ripple) {
    background: none;
}


.refine-footer {
    display: flex;
    justify-content: space-between;
    padding: 0px 1.5em 1.5em 1.5em;
}

.refine-left-footer {
    display: flex;
    flex-direction: column;
    color: #A3A3A3;
    font-size: 14px;
    font-weight: 500;
}

.note {
    text-transform: uppercase;
}

.refine-right-footer {
    display: flex;
    gap: 8px;
    align-items: center;
    border-radius: 8px;
    padding: 8px 20px;
    color: white;
    background-color: var(--primary-font-color);
}

.compare-container {
    max-width: none;
    padding: 3em;
}

.compare-container-header {
    display: flex;
    gap: 1em;
    align-items: center;
    color: white;
}

.back-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1em;
    background-color: #FFFFFF;
    border: 1px solid #E5E5E5;
    border-radius: 50%;
}

.compare-select-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0em 0.3em;
}

.select-download-wrapper {
    display: flex;
    align-items: center;
    gap: 1em;
}

.compare-content {
    display: flex;
    justify-content: space-between;
    gap: 2em;
}

.select-version {
    max-width: 250px;
    background-color: white;
    border-radius: 30px;
    color: #171717;
    font-weight: 500;
}

.select-version :deep(.v-field__outline) {
    display: none;
}

.select-version :deep(.v-list-item__content) {
    text-transform: uppercase;
}

.selection-list {
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 0.5em;
    padding: 0.5em 1em;
    border-bottom: 1px solid #EEEEEE;
    color: #171717;
    cursor: pointer;
}

.selected-item {
    color: #171717;
}

.last-item {
    border: none;
}

.tick-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    padding: 8px;
    border-radius: 50%;
    background-color: #171717;
    color: white;
}

.final-pr {
    display: flex;
    gap: 0.5em;
    justify-content: center;
    align-items: center;
    padding: 8px 20px;
    border-radius: 8px;
    background: var(--primary-gradient-with-black);
    color: white;
}

.final-pr img {
    width: 15px;
    height: 20px;
}

.footer-final-btn {
    padding-left: 8px;
    margin-bottom: 1em;
}

.pr-title {
    font-weight: 600;
    font-size: 24px;
}

.pr-details-wrapper{
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>